// @flow
import $ from 'jquery';
import JQueryView, { on } from '../../../common/JQueryView';

export default class IndexView extends JQueryView {
  constructor() {
    super('.request-container');
  }

  @on({ event: 'click', selector: '.cancel-information' })
  onClickCancelInformation() {
    $('.information').addClass('d-none');
  }

  @on({ event: 'click', selector: 'tr[data-href]' })
  onClickIRRequest(e: any) {
    const td = $(e.target).closest('td');
    if (!td.hasClass('js-delete-icon')) {
      const isLink = $(e.target).hasClass('link');
      if (isLink) return;
      window.location = $(e.currentTarget).data('href');
    }
  }
}
